import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { AuthService } from '../../services/auth.service';
import { Router, RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { LogoComponent } from '../shared/ui/ui';

@Component({
  selector: 'app-registration',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    LogoComponent
  ],
  templateUrl: './registration.component.html',
  styleUrl: './registration.component.scss'
})
export class RegistrationComponent implements OnInit {

  registrationForm!: FormGroup;
  registrationSuccess = false;
  /** null until the API answers; the form stays hidden meanwhile so it doesn't flash before a "closed" notice. */
  registrationOpen: boolean | null = null;
  loading = false;
  errorMessage = '';

  constructor(private fb: FormBuilder, private authService: AuthService, private router: Router) { }

  ngOnInit(): void {
    this.registrationForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: [''],
      company: ['', Validators.required]
    });

    this.authService.getRegistrationStatus().subscribe({
      next: ({ enabled }) => this.registrationOpen = enabled,
      // If the status can't be read, show the form: the register endpoint enforces the setting anyway.
      error: () => this.registrationOpen = true
    });
  }

  onSubmit() {
    if (this.registrationForm.invalid) {
      this.registrationForm.markAllAsTouched();
      return;
    }

    this.errorMessage = '';
    this.loading = true;

    this.authService.registerUser(this.registrationForm.value).subscribe({
      next: () => {
        this.registrationSuccess = true;
        this.registrationForm.reset();
        this.loading = false;
      },
      error: (error) => {
        if (error?.status === 403) {
          // Closed after the page loaded.
          this.registrationOpen = false;
          this.loading = false;
          return;
        }
        this.errorMessage = error?.error?.message || 'We couldn’t create your account. Please try again.';
        this.loading = false;
      }
    });
  }

  goToLogin() {
    this.router.navigate(['/login']);
  }
}
